<template>
  <div class="overall-bg p-0">
    <b-container class="mt-0">
      <div class="reports-div">
        <div class="first-div">
          <div class="reports-list" v-for="item in ReportsList">
            <b-button @click="reportsCollapse(item)" class="m-1" :class="item.visible ? null : 'collapsed'">
              <div class="d-flex align-items-center">
                <span>{{ item.report_label_name }}</span>
              </div>
              <div v-if="item.child_array.length > 0">
                <i class="pi pi-angle-up"></i>
              </div>
            </b-button>
            <b-collapse :id="item.crystal_report_param_id" :visible="item.visible" accordion="my-accordion"
              role="tabpanel" :class="item.visible ? null : 'collapsed'">
              <ul v-for="(item1, index) in item.child_array">
                <li v-if="item1.child_array.length > 0" class="d-flex align-items-center justify-content-between"
                  :v-b-toggle="item1.crystal_report_param_id" @click="item1.visible = !item1.visible">
                  <span>{{ item1.report_label_name }}</span><span><i class="pi pi-angle-down"></i></span>
                </li>
                <li v-else class="d-flex align-items-center justify-content-between"
                  :class="{ 'active-report': ActiveIndex === index }" @click="GetFieldList(item1, index)">
                  <span>{{ item1.report_label_name }}</span><span></span>
                </li>
                <b-collapse :id="item1.crystal_report_param_id" :visible="item1.visible" class="mt-2">
                  <ul v-for="item2 in item1.child_array">
                    <li>{{ item2.report_label_name }}</li>
                  </ul>
                </b-collapse>
              </ul>
            </b-collapse>
          </div>
        </div>

        <div class="second-div">
          <div v-if="showsecondiv">
            <b-container fluid>
              <b-form @submit.prevent="IsSubmit">
                <b-row>
                  <b-col class="compo-heading my-4">{{ ReportTitle }}</b-col>
                </b-row>
                <b-row class="py-2">
                  <b-col xxl="3" lg="4" md="4" cols="12" v-for="item in FieldsList">
                    <div class="field" v-if="item.field_status == 4">
                      <TextField :label="item.label_name" v-model="item.textfield" :required-icon="item.IsMandatory"
                        :rules="{ required: item.IsMandatory }" :id="item.label_name" :name="item.label_name"
                        @keyup="TextfieldOnChange" />
                    </div>
                    <div class="field" v-if="item.field_status == 5">
                      <CustomDropdown :label="item.label_name" :required-icon="item.IsMandatory"
                        :rules="{ required: item.IsMandatory }" :id="item.label_name" :name="item.label_name"
                        @change="DropdownOnChange(item.dropdown)" :items="ExpiryDaysOption" v-model="item.dropdown" />
                    </div>
                    <div class="field" v-if="item.field_status == 1">
                      <DatePicker :label="item.label_name" v-model="DataItems.fromdate" :name="item.label_name"
                        :id="item.label_name" :required-icon="item.IsMandatory" :rules="{ required: item.IsMandatory }"
                        :maxDate="TodayDate" @date-select="DateOnChange" />
                    </div>
                    <div class="field" v-if="item.field_status == 2">
                      <DatePicker :label="item.label_name" v-model="DataItems.Todate" :name="item.label_name"
                        :id="item.label_name" :required-icon="item.IsMandatory" :rules="{ required: item.IsMandatory }"
                        :maxDate="TodayDate" :minDate="new Date(DataItems.fromdate)" @date-select="DateOnChange" />
                    </div>
                    <div class="field" v-if="
                      item.field_status == 3 &&
                      (item.label_name == 'Store' ||
                        item.label_name == 'From Store')
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.StoreId" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="selectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>
                    <div class="field" v-if="
                      item.field_status == 3 && item.label_name == 'Item Name'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.ItemId" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="ItemselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>
                    <div class="field" v-if="
                      item.field_status == 3 &&
                      (item.label_name == 'DocNO' ||
                        item.label_name == 'Doc no')
                    ">
                      Doc No
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.DocNo" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="DocNoselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>
                    <div class="field" v-if="
                      item.field_status == 3 &&
                      item.label_name == 'Consumption Code'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.ConsumptionCode" :items="item.Options"
                        class="autoItem" :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="ConsumptionCodeselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>
                    <div class="field" v-if="
                      item.field_status == 3 &&
                      (item.label_name == 'GRN No' ||
                        item.label_name == 'GRN no')
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.GRNNo" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="GRNNoselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 &&
                      (item.label_name == 'Supplier Name' ||
                        item.label_name == 'Supplier')
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.SupplierId" :items="item.Options"
                        class="autoItem" :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="SupplierselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>
                    <div class="field" v-if="
                      item.field_status == 3 &&
                      item.label_name == 'Category Name'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.CategoryId" :items="item.Options"
                        class="autoItem" :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="CategoryselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 && item.label_name == 'Group'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.GroupId" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="groupselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 && item.label_name == 'Sub Group'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.SubGroupId" :items="item.Options"
                        class="autoItem" :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="subGroupselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 &&
                      (item.label_name == 'To Store' ||
                        item.label_name == 'Location')
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.ToStoreId" :items="item.Options"
                        class="autoItem" :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="tostoreselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 && item.label_name == 'Brand'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.BrandId" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="brandselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 && item.label_name == 'Model'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.ModelId" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="modelselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="item.field_status == 3 && item.label_name == 'Size'">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.SizeId" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="sizeselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>

                    <div class="field" v-if="
                      item.field_status == 3 && item.label_name == 'Batch No'
                    ">
                      <label>{{ item.label_name
                      }}<span class="red" v-if="item.IsMandatory">
                          *</span></label>
                      <AutoCompleteCustom v-model="AutoCompleteNameList.BatchNo" :items="item.Options" class="autoItem"
                        :name="item.label_name" :id="item.label_name" @input="loadoptions(item)"
                        @item-select="BatchnoselectOptions" :rules="{ required: item.IsMandatory }"
                        :required-icon="item.IsMandatory" />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex align-items-center justify-content-end gap-3">
                    <!-- <Footer CancelLabel="Clear" @cancel="BtnCancel" label="Submit" :loading="SubmitLoader" /> -->
                    <Cancel @canclebtn="BtnCancel" btnname="Clear" />
                    <Save size="sm" variant="primary" type="submit" label="View" :loading="SubmitLoader" />
                    <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print"
                      v-if="docshow && ReportUrl && iframeLoaded" />
                  </b-col>
                </b-row>
              </b-form>
            </b-container>
          </div>
          <!-- <div class="my-5 px-5" v-if="docshow && ReportUrl && iframeLoaded">
            <b-col>
              <Button label="Print" severity="success" icon="pi pi-print" class="printbtn" @click="Print" />
            </b-col>
          </div> -->
          <div class="my-5 px-5" v-if="docshow">
            <b-row>
              <b-col>
                <iframe :src="ReportUrl" class="iframe-class" loading="lazy" @load="onIframeLoad"></iframe>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import DatePicker from "../../../../components/FormComponents/DatePicker.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import Save from "../../../../components/GeneralButtons/SaveButton.vue";
import Cancel from "../../../../components/GeneralButtons/CancelButtton.vue";
import ReportsService from "../../../../modules/Inventory/Service/reportsService";
import AutoCompleteCustom from "../../../../components/FormComponents/AutoComplete.vue";
import moment from "moment";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import commonservice from "../../../../modules/Inventory/Service/StoreService";
import service from "../../../../modules/Inventory/Service/ItemMasService";
import StockInService from "../../../../modules/Inventory/Service/StockInService";
import StockOutService from "../../../../modules/Inventory/Service/StockOutService";
import PackageMAsterservice from "../../../../modules/Inventory/Service/PackageMasterService";
import GroupService from "../../../../modules/Inventory/Service/GroupService";
import SubgroupService from "../../../../modules/Inventory/Service/SubgroupService";
import GenericService from "../../../../modules/Inventory/Service/GenericMasterService";
import PacksizeService from "../../../../modules/Inventory/Service/PackSizeService";
import itemService from "../../../../modules/Inventory/Service/ItemMasService";
import StoreMasterService from "../../../../modules/Inventory/Service/StoreService";
import StockReasonService from "../../../../modules/Inventory/Service/StockReasonService";
import RoomService from "../../../../modules/Inventory/Service/RoomService";
import RackService from "../../../../modules/Inventory/Service/RackService";
import BoxService from "../../../../modules/Inventory/Service/BoxService";
import ManufacturerService from "../../../../modules/Inventory/Service/ManufacturerService";
import UnitMasService from "../../../../modules/Inventory/Service/UnitMasService";
import RowService from "../../../../modules/Inventory/Service/RowService";
import DeliveryTermsService from "../../../../modules/Inventory/Service/DeliveryTermsService";
import DeliveryModeMasService from "../../../../modules/Inventory/Service/DeliveryModeMasService";
import OtherTermsService from "../../../../modules/Inventory/Service/OtherTermsService";
import PaymentTermsService from "../../../../modules/Inventory/Service/PaymentTermsService";
import supplierMasterService from "../../../../modules/Inventory/Service/SupplierMaster";
import HsnService from "../../../../modules/Inventory/Service/HsnService";
import SubTaxService from "../../../../modules/Inventory/Service/SubTaxService";
import TaxService from "../../../../modules/Inventory/Service/TaxService";
import WithoutStockAffectService from "../../../../modules/Inventory/Service/WithoutStockAffectService";
import ItemStoreMappingService from "../../../../modules/Inventory/Service/ItemStoreMappingService";
import StoreDropDown from "../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import { useToast } from "primevue/usetoast";
import { config } from "../../../../config.js";
import debounce from "lodash/debounce";
import ItemConfigurationService from "../../Service/ItemConfiguration";

export default defineComponent({
  components: {
    StoreDropDown,
    BacktoPage,
    Headerlayout,
    TextField,
    CustomDropdown,
    DatePicker,
    Footer,
    AutoCompleteCustom,
    Save,
    Cancel,
  },
  setup() {
    /* Variable Declaration*/
    const router = useRoute();
    const toast = useToast();
    let showsecondiv = ref(false);
    let docshow = ref(false);
    let ReportsList: any = ref([]);
    let ReportUrl = ref();
    let iframeLoaded = ref(false);
    let SubmitLoader = ref(false);
    let FieldsList: any = ref([]);
    let ReportTitle = ref("");
    const TodayDate = new Date();
    let DataItems = ref({
      LeadOption: [],
      LeadCode: ref(),
      fromdate: "",
      Todate: "",
      FormId: 0,
    });

    let StoreBranchId = ref(0);
    let FromStoreBrMapId = ref(0);

    let ObjDataItems = ref({
      fromdate: "",
      Todate: "",
      Id: 0,
      ExpiryDays: 0,
      itemid: 0,
      docno: 0,
      consumptioncode: 0,
      grnno: 0,
      supplierid: 0,
      categoryid: 0,
      hospitalid: 0,
      branchid: 0,
      groupid: 0,
      subgroupid: 0,
      tostoreid: 0,
      brandid: 0,
      modelid: 0,
      sizeid: 0,
      storebrmapid: 0,
      batchno: "",
    });

    let AutoCompleteNameList = ref({
      StoreId: ref(),
      ItemId: ref(),
      DocNo: ref(),
      ConsumptionCode: ref(),
      GRNNo: ref(),
      SupplierId: ref(),
      CategoryId: ref(),
      GroupId: ref(),
      SubGroupId: ref(),
      ToStoreId: ref(),
      BrandId: ref(),
      ModelId: ref(),
      SizeId: ref(),
      BatchNo: ref(),
    });

    let objstoreid = ref(0);

    const copyObjDataItems = JSON.parse(JSON.stringify(ObjDataItems.value));
    const copyDataItems = JSON.parse(JSON.stringify(DataItems.value));
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    /*---*/
    let usersData;

    //get local storage session data

    /*Functions*/
    onMounted(() => {
      let SessionUserData = localStorage.getItem("UsersData");
      if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
      }

      GetReportlist();
    });
    //Get Reports List
    async function GetReportlist() {
      debugger;
      try {
        debugger;
        const result = await ReportsService.getReportList();
        console.log(result);
        let resutltArrHead: any = result["result"]
          .filter((item) => item.is_head == 1 && item.parent == 0)
          .sort((a, b) => a.display_order - b.display_order);
        let resutltArrfirstParent: any = result["result"]
          .filter((item) => item.is_head == 1 && item.parent != 0)
          .sort((a, b) => a.display_order - b.display_order);
        let resutltArrChild: any = result["result"]
          .filter((item) => item.is_head == 0 && item.parent != 0)
          .sort((a, b) => a.display_order - b.display_order);
        Object.values(resutltArrHead).forEach((items: any) => {
          items["visible"] = false;
          let arrchild: any = [];
          resutltArrChild.forEach((element: any) => {
            if (element.parent == items.crystal_report_param_id) {
              arrchild.push({
                report_form_id: element.report_form_id,
                crystal_report_param_id: element.crystal_report_param_id,
                report_label_name: element.report_label_name,
                child_array: [],
                DocType: element.DocType,
              });
            }
          });
          resutltArrfirstParent.forEach((element: any) => {
            let arrchild1: any = [];
            element["visible"] = false;
            resutltArrChild.forEach((element1: any) => {
              if (element1.parent == element.crystal_report_param_id) {
                arrchild1.push({
                  report_form_id: element.report_form_id,
                  crystal_report_param_id: element.crystal_report_param_id,
                  report_label_name: element.report_label_name,
                  child_array: [],
                  DocType: element.DocType,
                });
              }
            });
            if (element.parent == items.crystal_report_param_id) {
              arrchild.push({
                report_form_id: element.report_form_id,
                crystal_report_param_id: element.crystal_report_param_id,
                report_label_name: element.report_label_name,
                child_array: arrchild1,
                visible: element.visible,
                DocType: element.DocType,
              });
            }
          });
          items["child_array"] = arrchild;
        });
        ReportsList.value = resutltArrHead;
        console.log(ReportsList.value);
      } catch (error) {
        console.log(error);
      }
    }

    let reprtname = ref(0);
    let doctype = ref(0);
    let ActiveIndex = ref();

    //Get Field List
    async function GetFieldList(paramId, index) {
      debugger;
      try {
        BtnCancel();
        IsClear();
        AutoCompleteNameList.value.StoreId = ref();
        AutoCompleteNameList.value.ItemId = ref();
        AutoCompleteNameList.value.DocNo = ref();
        AutoCompleteNameList.value.ConsumptionCode = ref();
        AutoCompleteNameList.value.GRNNo = ref();
        AutoCompleteNameList.value.SupplierId = ref();
        AutoCompleteNameList.value.CategoryId = ref();

        AutoCompleteNameList.value.GroupId = ref();
        AutoCompleteNameList.value.SubGroupId = ref();
        AutoCompleteNameList.value.ToStoreId = ref();
        AutoCompleteNameList.value.BrandId = ref();
        AutoCompleteNameList.value.ModelId = ref();
        AutoCompleteNameList.value.SizeId = ref();

        ActiveIndex.value = index;
        ReportTitle.value = paramId.report_label_name;
        FieldsList.value = [];
        reprtname.value = 0;
        doctype.value = 0;
        ReportUrl.value = "";
        docshow.value = false;
        DataItems.value.FormId = paramId.report_form_id;
        const result = await ReportsService.getFieldList(
          paramId.report_form_id
        );
        console.log(result);
        if (result["result"].length > 0) {
          FieldsList.value = result["result"].map((item) => {
            item.modelvalue = "";
            return item;
          });
          showsecondiv.value = true;
          console.log(FieldsList.value);

          // Focus on the first field after the DOM is updated
          setTimeout(() => {
            focusFirstField();
          }, 100);
        }
        // alert(paramId.report_form_id)

        reprtname.value = paramId.report_form_id;

        doctype.value = paramId.DocType;
      } catch (error) {
        console.log(error);
      }
    }

    // Function to focus on the first input field
    function focusFirstField() {
      // Try to find the first input field based on different field types
      const firstTextField = document.querySelector(
        '.field input[type="text"]'
      ) as HTMLInputElement;
      const firstDropdown = document.querySelector(
        ".field .p-dropdown-trigger"
      ) as HTMLElement;
      const firstDatePicker = document.querySelector(
        ".field .p-datepicker-trigger"
      ) as HTMLElement;
      const firstAutoComplete = document.querySelector(
        ".field .p-autocomplete-input"
      ) as HTMLInputElement;

      // Focus on the first available field
      if (firstTextField) {
        firstTextField.focus();
      } else if (firstDropdown) {
        firstDropdown.click();
      } else if (firstDatePicker) {
        firstDatePicker.click();
      } else if (firstAutoComplete) {
        firstAutoComplete.focus();
      }
    }

    //Collapse all report list other than active accordian
    function reportsCollapse(item1) {
      debugger;
      const isOpening = !item1.visible;

      ReportsList.value = ReportsList.value.map((item) => {
        if (item.crystal_report_param_id == item1.crystal_report_param_id) {
          item1.visible = !item1.visible;
        } else {
          item.visible = false;
        }
        return item;
      });

      if (isOpening && item1.child_array && item1.child_array.length > 0) {
        GetFieldList(item1.child_array[0], 0);
      } else if (!isOpening) {
        BtnCancel();
        showsecondiv.value = false;
        ActiveIndex.value = null;
      }
    }

    const loadoptions = async (item) => {
      debugger;
      docshow.value = false;
      iframeLoaded.value = false;
      ReportUrl.value = "";

      if (item.label_name === "Store" || item.label_name === "From Store") {
        loadStore(item);
        return;
      } else if (
        item.label_name === "To Store" ||
        item.label_name === "Location"
      ) {
        loadToStore(item);
        return;
      } else if (item.label_name === "Item Name") {
        loadItem(item);
        return;
      } else if (item.label_name === "Category Name") {
        storeCategoryMapping(item);
        return;
      }

      if (reprtname.value === 2) {
        loadStockin(item);
        return;
      } else if (reprtname.value === 52) {
        packageMaster(item);
        return;
      } else if (item.label_name === "Group") {
        groupMaster(item);
        return;
      } else if (reprtname.value === 18) {
        storeCategoryMap(item);
        return;
      } else if (reprtname.value === 19) {
        storeCategoryItemMap(item);
        return;
      } else if (item.label_name === "Sub Group") {
        subGroupMaster(item);
        return;
      } else if (reprtname.value === 22) {
        genericMaster(item);
        return;
      } else if (reprtname.value === 23) {
        batchMaster(item);
        return;
      } else if (reprtname.value === 24) {
        itemMaster(item);
        return;
      } else if (reprtname.value === 25) {
        stockReasonMaster(item);
        return;
      } else if (reprtname.value === 26) {
        unitMaster(item);
        return;
      } else if (reprtname.value === 27) {
        manufacturerMaster(item);
        return;
      } else if (reprtname.value === 28) {
        boxMaster(item);
        return;
      } else if (reprtname.value === 29) {
        rackMaster(item);
        return;
      } else if (reprtname.value === 30) {
        roomMaster(item);
        return;
      } else if (reprtname.value === 31) {
        rowMaster(item);
        return;
      } else if (reprtname.value === 32) {
        storeMaster(item);
        return;
      } else if (reprtname.value === 33) {
        deliveryTermMaster(item);
        return;
      } else if (reprtname.value === 34) {
        deliveryModeMaster(item);
        return;
      } else if (reprtname.value === 35) {
        otherTermsMaster(item);
        return;
      } else if (reprtname.value === 36) {
        paymentTermsMaster(item);
        return;
      } else if (
        item.label_name === "Supplier Name" ||
        item.label_name === "Supplier"
      ) {
        supplierMaster(item);
        return;
      } else if (reprtname.value === 38) {
        hsnMaster(item);
        return;
      } else if (reprtname.value === 39) {
        subTaxMaster(item);
        return;
      } else if (reprtname.value === 40) {
        taxMaster(item);
        return;
      } else if (reprtname.value === 10 || reprtname.value === 5) {
        loadstockout(item);
        return;
      } else if (
        reprtname.value === 9 ||
        reprtname.value === 11 ||
        reprtname.value === 41 ||
        reprtname.value === 14 ||
        reprtname.value === 56
      ) {
        loadstockWA(item);
        return;
      } else if (
        item.label_name === "Brand" ||
        item.label_name === "Model" ||
        item.label_name === "Size"
      ) {
        LoadItemConfigurations(item, item.label_name);
        return;
      } else if (item.label_name == "Batch No") {
        loadBatchno(item);
        return;
      }
    };

    const ItemselectOptions = (item) => {
      debugger;
      ObjDataItems.value.itemid = item.value.Id;
    };

    const DocNoselectOptions = (item) => {
      debugger;
      ObjDataItems.value.Id = item.value.Id;
    };

    const ConsumptionCodeselectOptions = (item) => {
      debugger;
      ObjDataItems.value.Id = item.value.Id;
    };

    const GRNNoselectOptions = (item) => {
      debugger;
      ObjDataItems.value.Id = item.value.Id;
    };

    const SupplierselectOptions = (item) => {
      debugger;
      ObjDataItems.value.supplierid = item.value.Id;
    };

    const CategoryselectOptions = (item) => {
      debugger;
      ObjDataItems.value.categoryid = item.value.value;
    };

    const groupselectOptions = (item) => {
      debugger;
      ObjDataItems.value.groupid = item.value.value;
    };

    const subGroupselectOptions = (item) => {
      debugger;
      ObjDataItems.value.subgroupid = item.value.value;
    };

    const tostoreselectOptions = (item) => {
      debugger;
      ObjDataItems.value.tostoreid = item.value.Id;
      ObjDataItems.value.storebrmapid = item.value.StoreBranchMapId;
    };

    const brandselectOptions = (item) => {
      debugger;
      ObjDataItems.value.brandid = item.value.Id;
    };

    const modelselectOptions = (item) => {
      debugger;
      ObjDataItems.value.modelid = item.value.Id;
    };

    const sizeselectOptions = (item) => {
      debugger;
      ObjDataItems.value.sizeid = item.value.Id;
    };

    const BatchnoselectOptions = (item) => {
      debugger;
      ObjDataItems.value.batchno = item.value.value;
    };

    const selectOptions = (item) => {
      debugger;

      ObjDataItems.value.Id = item.value.value;
      objstoreid.value = item.value.value;
      StoreBranchId.value = item.value.BranchId ? item.value.BranchId : 0;
      FromStoreBrMapId.value = item.value.StoreBranchMapId
        ? item.value.StoreBranchMapId
        : 0;

      // if (reprtname.value === 13 && item.value.StoreTypeId) {
      //   ObjDataItems.value.Id = item.value.Id
      //   objstoreid.value = item.value.Id
      // } else if (reprtname.value === 13 && !item.value.StoreTypeId) {
      //   ObjDataItems.value.itemid = item.value.Code

      // } else if (reprtname.value === 2) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 52) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 16) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 20) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 22) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 23) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 24) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 25) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 26) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 27) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 28) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 29) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 30) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 31) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 32) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 33) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 34) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 35) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 36) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 37) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 38) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 39) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 40) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 14) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 41) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 56) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 10 || reprtname.value === 5) {
      //   ObjDataItems.value.Id = item.value.value.toString()
      // } else if (reprtname.value === 11) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 9) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 4) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 77) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 6) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 43) {
      //   ObjDataItems.value.Id = item.value.value
      // }

      // else if (reprtname.value === 82) {
      //   ObjDataItems.value.Id = item.value.value
      //   objstoreid.value = item.value.Id
      // }
      // else if (reprtname.value === 83) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 84) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 85) {
      //   ObjDataItems.value.Id = item.value.value
      //   objstoreid.value = item.value.Id
      // }
      // else if (reprtname.value === 86) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 87) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 88) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 89) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 90) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 91) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 92) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 93) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 94) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 95) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 96) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 97) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 98) {
      //   ObjDataItems.value.Id = item.value.value
      // }
      // else if (reprtname.value === 99) {
      //   ObjDataItems.value.Id = item.value.value
      //   objstoreid.value = item.value.Id
      // }
      // else if (reprtname.value === 100) {
      //   ObjDataItems.value.Id = item.value.value
      //   objstoreid.value = item.value.Id
      // } else if (reprtname.value === 101) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 102) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 103) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 104) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 105) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 106) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 107) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 108) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 109) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 110) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 111) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 112) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 113) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 114) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 115) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 116) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 117) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 118) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 119) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 120) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 121) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 122) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 123) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 124) {
      //   ObjDataItems.value.Id = item.value.value
      // } else if (reprtname.value === 125) {
      //   ObjDataItems.value.Id = item.value.value
      // }
    };

    // const loadoptions = async (item) => {
    //   debugger;
    //   if (item.field_id === "storeid") {
    //     loadStore(item);
    //   } else if (item.field_id === "itemid") {
    //     loadItem(item);
    //   } else if (item.field_id === "supplierid") {
    //     supplierMaster(item);
    //   } else if (item.field_id === "categoryid") {
    //     LoadCategory(item);
    //   }

    //   if (reprtname.value === 2) {
    //     loadStockin(item);
    //   } else if (reprtname.value === 52) {
    //     packageMaster(item);
    //   } else if (reprtname.value === 16) {
    //     groupMaster(item);
    //   } else if (reprtname.value === 18) {
    //     storeCategoryMap(item);
    //   } else if (reprtname.value === 19) {
    //     storeCategoryItemMap(item);
    //   } else if (reprtname.value === 20) {
    //     subGroupMaster(item);
    //   } else if (reprtname.value === 22) {
    //     genericMaster(item);
    //   } else if (reprtname.value === 23) {
    //     batchMaster(item);
    //   } else if (reprtname.value === 24) {
    //     itemMaster(item);
    //   } else if (reprtname.value === 25) {
    //     stockReasonMaster(item);
    //   } else if (reprtname.value === 26) {
    //     unitMaster(item);
    //   } else if (reprtname.value === 27) {
    //     manufacturerMaster(item);
    //   } else if (reprtname.value === 28) {
    //     boxMaster(item);
    //   } else if (reprtname.value === 29) {
    //     rackMaster(item);
    //   } else if (reprtname.value === 30) {
    //     roomMaster(item);
    //   } else if (reprtname.value === 31) {
    //     rowMaster(item);
    //   } else if (reprtname.value === 32) {
    //     storeMaster(item);
    //   } else if (reprtname.value === 33) {
    //     deliveryTermMaster(item);
    //   } else if (reprtname.value === 34) {
    //     deliveryModeMaster(item);
    //   } else if (reprtname.value === 35) {
    //     otherTermsMaster(item);
    //   } else if (reprtname.value === 36) {
    //     paymentTermsMaster(item);
    //   } else if (reprtname.value === 37) {
    //     supplierMaster(item);
    //   } else if (reprtname.value === 38) {
    //     hsnMaster(item);
    //   } else if (reprtname.value === 39) {
    //     subTaxMaster(item);
    //   } else if (reprtname.value === 40) {
    //     taxMaster(item);
    //   } else if (reprtname.value === 10 || reprtname.value === 5) {
    //     loadstockout(item);
    //   } else if (
    //     reprtname.value === 9 ||
    //     reprtname.value === 11 ||
    //     reprtname.value === 41 ||
    //     reprtname.value === 14 ||
    //     reprtname.value === 56
    //   ) {
    //     loadstockWA(item);
    //   }
    // };

    // // const selectOptions = (item) => {
    // //   debugger;
    // //   // Ensure field_id is defined
    // //   if (item.field_id) {
    // //     // Dynamically add the property if it doesn't exist
    // //     if (!ObjDataItems.value.hasOwnProperty(item.field_id)) {
    // //       ObjDataItems.value[item.field_id] = null;
    // //     }

    // //     if (
    // //       item.autocompleteValue.value &&op
    // //       item.autocompleteValue.value != undefined
    // //     ) {
    // //       ObjDataItems.value[item.field_id] = item.autocompleteValue.value;
    // //     } else if (item.textfieldValue && item.textfieldValue != undefined) {
    // //       ObjDataItems.value[item.field_id] = item.textfieldValue;
    // //     } else if (item.dropdownValue && item.dropdownValue != undefined) {
    // //       ObjDataItems.value[item.field_id] = item.dropdownValue;
    // //     }
    // //   } else {
    // //     console.error("field_id is undefined for the selected item:", item);
    // //   }
    // // };

    // const selectOptions = (item) => {
    //   debugger;
    //   if (reprtname.value === 13 && item.value.StoreTypeId) {
    //     ObjDataItems.value.Id = item.value.Id
    //     objstoreid.value = item.value.Id
    //   } else if (reprtname.value === 13 && !item.value.StoreTypeId) {
    //     ObjDataItems.value.itemid = item.value.Code

    //   } else if (reprtname.value === 2) {
    //     ObjDataItems.value.Id = item.value.value
    //   } else if (reprtname.value === 52) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 16) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 20) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 22) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 23) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 24) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 25) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 26) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 27) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 28) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 29) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 30) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 31) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 32) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 33) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 34) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 35) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 36) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 37) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 38) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 39) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 40) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 14) {
    //     ObjDataItems.value.Id = item.value.value
    //   } else if (reprtname.value === 41) {
    //     ObjDataItems.value.Id = item.value.value
    //   } else if (reprtname.value === 56) {
    //     ObjDataItems.value.Id = item.value.value
    //   } else if (reprtname.value === 10 || reprtname.value === 5) {
    //     ObjDataItems.value.Id = item.value.value.toString()
    //   } else if (reprtname.value === 11) {
    //     ObjDataItems.value.Id = item.value.value
    //   } else if (reprtname.value === 9) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 43) {
    //     ObjDataItems.value.Id = item.value.value
    //   }

    //   else if (reprtname.value === 82) {
    //     ObjDataItems.value.Id = item.value.value
    //     objstoreid.value = item.value.Id
    //   }
    //   else if (reprtname.value === 83) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 84) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 85) {
    //     ObjDataItems.value.Id = item.value.value
    //     objstoreid.value = item.value.Id
    //   }
    //   else if (reprtname.value === 86) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 93) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 95) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 98) {
    //     ObjDataItems.value.Id = item.value.value
    //   }
    //   else if (reprtname.value === 99) {
    //     ObjDataItems.value.Id = item.value.value
    //     objstoreid.value = item.value.Id
    //   }
    //   else if (reprtname.value === 100) {
    //     ObjDataItems.value.Id = item.value.value
    //     objstoreid.value = item.value.Id
    //   }
    // }

    const loadStore = async (data) => {
      debugger;

      let result = await commonservice.StoreDropDownListByUserId(
        usersData.UserId,
        usersData.OrganizationId,
        usersData.Admin,
        usersData.BranchId
      );

      let regex = new RegExp(AutoCompleteNameList.value.StoreId, "i");

      let branchIds =
        typeof usersData.BranchId === "string" &&
          usersData.BranchId.includes(",")
          ? usersData.BranchId.split(",")
          : [usersData.BranchId.toString()];

      data.Options = result["result"]
        .map((item: any) => {
          if (branchIds.length == 1) {
            item.label = item.Name + " - " + "(" + item.CurrentBranchName + ")";
          } else {
            item.label = item.Name + " - " + "(" + item.CurrentBranchName + ")";
          }

          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.Name));

      ObjDataItems.value.tostoreid = 0;
      ObjDataItems.value.storebrmapid = 0;
      AutoCompleteNameList.value.ToStoreId = "";
    };

    const loadToStore = async (data) => {
      debugger;
      try {
        let result = await commonservice.getStoreByStoreId(
          Number(objstoreid.value),
          usersData.OrganizationId,
          StoreBranchId.value
        );

        let regex = new RegExp(AutoCompleteNameList.value.ToStoreId, "i");

        data.Options = result["result"]
          .filter((x) => x.StoreBranchMapId != Number(FromStoreBrMapId.value))
          .map((item: any) => {
            item.label = item.Name;
            item.value = item.Id;
            return item;
          })
          .filter((f) => regex.test(f.Name));
      } catch (error) {
        console.error("Error in loadToStore:", error);
      }
    };

    const loadItem = async (data) => {
      debugger;
      if (
        AutoCompleteNameList.value.ItemId === "" ||
        AutoCompleteNameList.value.ItemId.length >= 3
      ) {
        const result = await service.ListItemSearchByStoreId(
          Number(objstoreid.value)
            ? Number(objstoreid.value)
            : Number(currentstore),
          usersData.BranchId,
          usersData.OrganizationId,
          AutoCompleteNameList.value.ItemId
        );

        let regex = new RegExp(AutoCompleteNameList.value.ItemId, "i");
        data.Options = result["result"]
          .map((item: any) => {
            item.label = item.Name;
            item.value = item.Id;
            return item;
          })
          .filter((f) => regex.test(f.Name));
      }
    };

    let currentstore = router.query.Id;

    const loadStockin = async (data) => {
      debugger;
      console.log(AutoCompleteNameList.value.GRNNo);
      let result = await StockInService.GetStockInTMTableListByDocNo(
        String(AutoCompleteNameList.value.GRNNo),
        currentstore,
        String(doctype.value)
      );

      let regex = new RegExp(AutoCompleteNameList.value.GRNNo, "i");
      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.DocNo;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.DocNo));
    };

    const loadstockWA = async (data) => {
      debugger;
      let result = await WithoutStockAffectService.GetListByDocNo(
        String(AutoCompleteNameList.value.DocNo),
        currentstore,
        String(doctype.value)
      );
      console.log(result);
      let regex = new RegExp(AutoCompleteNameList.value.DocNo, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.DocNo;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.DocNo));
    };

    const loadstockout = async (data) => {
      debugger;
      let result = await StockOutService.GetListByDocNoCustom(
        String(AutoCompleteNameList.value.DocNo),
        currentstore,
        String(doctype.value)
      );
      console.log(result);
      let regex = new RegExp(AutoCompleteNameList.value.DocNo, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.DocNo;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.DocNo));
    };

    const packageMaster = async (data) => {
      const result = await PackageMAsterservice.getdata();
      console.log(result);
      if (usersData.Admin == 1) {
        result["result"] = result["result"].filter(
          (items) => items.HospitalId == usersData.OrganizationId
        );
      } else {
        result["result"] = result["result"].filter(
          (items) =>
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      data.Options = result["result"].map((item: any) => {
        item.label = item.PackageName;
        item.value = item.Id;
        return item;
      });
    };

    const groupMaster = async (data) => {
      debugger;

      const result = await GroupService.getdata();
      console.log(result);

      if (AutoCompleteNameList.value.CategoryId == "") {
        ObjDataItems.value.categoryid = 0;
      }

      let regex = new RegExp(AutoCompleteNameList.value.GroupId, "i");

      result["result"] = result["result"].filter(
        (item) =>
          item.HospitalId == usersData.OrganizationId &&
          (!ObjDataItems.value.categoryid ||
            item.ProductTypeId == ObjDataItems.value.categoryid) &&
          regex.test(item.Name)
      );

      data.Options = result["result"].map((item) => ({
        label: item.Name,
        value: item.Id,
      }));

      ObjDataItems.value.subgroupid = 0;
      AutoCompleteNameList.value.SubGroupId = "";
    };

    const subGroupMaster = async (data) => {
      debugger;

      const result = await SubgroupService.getdata();
      console.log(result);

      if (AutoCompleteNameList.value.GroupId == "") {
        ObjDataItems.value.groupid = 0;
      }

      let regex = new RegExp(AutoCompleteNameList.value.SubGroupId, "i");

      result["result"] = result["result"].filter(
        (items) =>
          items.HospitalId == usersData.OrganizationId &&
          (!ObjDataItems.value.groupid ||
            items.GroupId == ObjDataItems.value.groupid) &&
          regex.test(items.Name)
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const genericMaster = async (data) => {
      const result = await GenericService.getlistdata();
      console.log(result);
      if (usersData.Admin == 1) {
        result["result"] = result["result"].filter(
          (items) => items.HospitalId == usersData.OrganizationId
        );
      } else {
        result["result"] = result["result"].filter(
          (items) =>
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      data.Options = result["result"].map((item: any) => {
        item.label = item.GenericName;
        item.value = item.Id;
        return item;
      });
    };

    const batchMaster = async (data) => {
      const result = await PacksizeService.getlistdata();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      let regex = new RegExp(data.modelvalue, "i");
      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.Name;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.ItemName));
    };

    const itemMaster = async (data) => {
      let result;
      if (usersData.Admin == 1) {
        result = await itemService.getdata(usersData.OrganizationId);
        result["result"] = result["result"].filter(
          (items) => items.HospitalId == usersData.OrganizationId
        );
      } else {
        result = await StoreMasterService.StoreDropDownListByUserId(
          usersData.UserId,
          usersData.OrganizationId,
          usersData.Admin,
          usersData.BranchId
        );
        result["result"] = result["result"].filter(
          (items) =>
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      let regex = new RegExp(AutoCompleteNameList.value.ItemId, "i");
      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.ItemName;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.ItemName));
    };

    const stockReasonMaster = async (data) => {
      const result = await StockReasonService.getlistdata();
      console.log(result);

      let regex = new RegExp(data.modelvalue, "i");

      result["result"] = result["result"].filter(
        (items) =>
          items.HospitalId == usersData.OrganizationId &&
          regex.test(items.ReasonName)
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.ReasonName;
        item.value = item.Id;
        return item;
      });
    };

    const unitMaster = async (data) => {
      const result = await UnitMasService.getdata();
      console.log(result);

      let regex = new RegExp(data.modelvalue, "i");

      result["result"] = result["result"].filter(
        (items) =>
          items.HospitalId == usersData.OrganizationId &&
          regex.test(items.ReasonName)
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const manufacturerMaster = async (data) => {
      const result = await ManufacturerService.getdata();
      console.log(result);

      let regex = new RegExp(data.modelvalue, "i");

      result["result"] = result["result"].filter(
        (items) =>
          items.HospitalId == usersData.OrganizationId && regex.test(items.Name)
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const boxMaster = async (data) => {
      const result = await BoxService.getBoxList();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const rackMaster = async (data) => {
      const result = await RackService.getRackList();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const roomMaster = async (data) => {
      const result = await RoomService.getRoomList();
      console.log(result);

      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const rowMaster = async (data) => {
      const result = await RowService.getRowList();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const storeMaster = async (data) => {
      // const result = await commonservice.getStoreListByUserId(usersData.UserId,
      //   usersData.OrganizationId,
      //   usersData.Admin,
      //   usersData.BranchId
      // );
      const result = await commonservice.StoreDropDownListByUserId(
        usersData.UserId,
        usersData.OrganizationId,
        usersData.Admin,
        usersData.BranchId
      );
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      let regex = new RegExp(AutoCompleteNameList.value.StoreId, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.Name;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.Name));
    };

    const deliveryTermMaster = async (data) => {
      const result = await DeliveryTermsService.getdata();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.DeliTermsDesc;
        item.value = item.Id;
        return item;
      });
    };

    const deliveryModeMaster = async (data) => {
      const result = await DeliveryModeMasService.getdata();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.DeliveryModeDesc;
        item.value = item.Id;
        return item;
      });
    };

    const otherTermsMaster = async (data) => {
      const result = await OtherTermsService.getdata();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.OtherTermDesc;
        item.value = item.Id;
        return item;
      });
    };

    const paymentTermsMaster = async (data) => {
      const result = await PaymentTermsService.getdata();
      console.log(result);
      result["result"] = result["result"].filter(
        (items) => items.HospitalId == usersData.OrganizationId
      );

      data.Options = result["result"].map((item: any) => {
        item.label = item.PaymentTermsDesc;
        item.value = item.Id;
        return item;
      });
    };

    const supplierMaster = async (data) => {
      debugger;
      const result = await supplierMasterService.GetSuppliersByStoreId(
        router.query.Id,
        router.query.BranchId
      );
      console.log(result);
      let regex = new RegExp(AutoCompleteNameList.value.SupplierId, "i");
      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.Name;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.Name));
    };

    const hsnMaster = async (data) => {
      const result = await HsnService.getdata(usersData.OrganizationId);
      console.log(result);
      if (usersData.Admin == 1) {
        result["result"] = result["result"].filter(
          (items) => items.HospitalId == usersData.OrganizationId
        );
      } else {
        result["result"] = result["result"].filter(
          (items) =>
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      data.Options = result["result"].map((item: any) => {
        item.label = item.HSNName;
        item.value = item.Id;
        return item;
      });
    };

    const subTaxMaster = async (data) => {
      const result = await SubTaxService.getlistdata();
      console.log(result);
      if (usersData.Admin == 1) {
        result["result"] = result["result"].filter(
          (items) => items.HospitalId == usersData.OrganizationId
        );
      } else {
        result["result"] = result["result"].filter(
          (items) =>
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      data.Options = result["result"].map((item: any) => {
        item.label = item.Name;
        item.value = item.Id;
        return item;
      });
    };

    const taxMaster = async (data) => {
      const result = await TaxService.GetTaxTable(usersData.OrganizationId);
      console.log(result);
      if (usersData.Admin == 1) {
        result["result"] = result["result"].filter(
          (items) => items.HospitalId == usersData.OrganizationId
        );
      } else {
        result["result"] = result["result"].filter(
          (items) =>
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      data.Options = result["result"].map((item: any) => {
        item.label = item.TaxName;
        item.value = item.Id;
        return item;
      });
    };

    const storeCategoryMap = async (data) => {
      const result = await ItemStoreMappingService.liststorecatgorymapping(
        usersData.UserId,
        usersData.OrganizationId,
        usersData.Admin,
        usersData.BranchId
      );
      console.log(result);
      if (usersData.Admin == 1) {
        result["result"] = result["result"].filter(
          (items) =>
            items.StoreId == router.query.Id &&
            items.HospitalId == usersData.OrganizationId
        );
      } else {
        result["result"] = result["result"].filter(
          (items) =>
            items.StoreId == router.query.Id &&
            items.HospitalId == usersData.OrganizationId &&
            items.BranchId == usersData.BranchId
        );
      }
      let regex = new RegExp(AutoCompleteNameList.value.StoreId, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.StoreName;
          item.value = item.Id;
          return item;
        })
        .filter((f) => regex.test(f.StoreName));
    };

    const storeCategoryMapping = async (data) => {
      debugger;
      const result = await ItemStoreMappingService.StoreCategoryMappingget(
        ObjDataItems.value.Id || router.query.Id,
        usersData.BranchId
      );
      console.log(result);
      let regex = new RegExp(AutoCompleteNameList.value.CategoryId, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.CategoryName;
          item.value = item.CategoryId;
          return item;
        })
        .filter((f) => regex.test(f.CategoryName));

      ObjDataItems.value.groupid = 0;
      AutoCompleteNameList.value.GroupId = "";
    };

    const storeCategoryItemMap = async (data) => {
      debugger;
      const result = await ItemStoreMappingService.storecatlist();
      console.log(result);

      result["result"] = result["result"].filter(
        (items) =>
          items.HospitalId == usersData.OrganizationId &&
          items.BranchId == usersData.BranchId
      );

      let regex = new RegExp(AutoCompleteNameList.value.CategoryId, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.CategoryName;
          item.value = item.CategoryId;
          return item;
        })
        .filter((f) => regex.test(f.CategoryName));
    };

    async function LoadItemConfigurations(data, LableName) {
      debugger;
      try {
        const response = await ItemConfigurationService.List();

        if (LableName == "Brand") {
          let regexBrand = new RegExp(AutoCompleteNameList.value.BrandId, "i");

          data.Options = response["result"]
            .filter(
              (f) =>
                f.IsActive == true &&
                f.HospitalId == usersData.OrganizationId &&
                f.ICTypeId == 1
            )
            .map((item) => {
              item.label = item.Name;
              item.value = item.Id;
              return item;
            })
            .filter((f) => regexBrand.test(f.Name));
        }

        if (LableName == "Model") {
          let regexModel = new RegExp(AutoCompleteNameList.value.ModelId, "i");

          data.Options = response["result"]
            .filter(
              (f) =>
                f.IsActive == true &&
                f.HospitalId == usersData.OrganizationId &&
                f.ICTypeId == 2
            )
            .map((item) => {
              item.label = item.Name;
              item.value = item.Id;
              return item;
            })
            .filter((f) => regexModel.test(f.Name));
        }

        if (LableName == "Size") {
          let regexSize = new RegExp(AutoCompleteNameList.value.SizeId, "i");

          data.Options = response["result"]
            .filter(
              (f) =>
                f.IsActive == true &&
                f.HospitalId == usersData.OrganizationId &&
                f.ICTypeId == 3
            )
            .map((item) => {
              item.label = item.Name;
              item.value = item.Id;
              return item;
            })
            .filter((f) => regexSize.test(f.Name));
        }
      } catch (error) {
        alert(error);
      }
    }

    const loadBatchno = async (data) => {
      debugger;
      let result = await StockInService.ListBatchNoSearchByStoreId(
        Number(objstoreid.value)
          ? Number(objstoreid.value)
          : Number(currentstore),
        usersData.BranchId,
        usersData.OrganizationId,
        String(AutoCompleteNameList.value.BatchNo)
      );
      console.log(result);
      let regex = new RegExp(AutoCompleteNameList.value.BatchNo, "i");

      data.Options = result["result"]
        .map((item: any) => {
          item.label = item.BatchNo;
          item.value = item.BatchNo;
          return item;
        })
        .filter((f) => regex.test(f.BatchNo));
    };

    // //Load Lead AutoComplete
    // async function GetByLeadCode() {
    //   const result = await ReportsService.GetByLeadCode(
    //     DataItems.value.LeadCode
    //   );
    //   DataItems.value.LeadOption = result["result"].map((item: any) => {
    //     item.label = item.LeadCode;
    //     item.value = item.Id;

    //     return item;
    //   });
    // }

    const onIframeLoad = () => {
      iframeLoaded.value = true;
      SubmitLoader.value = false;
    };

    const BtnCancel = () => {
      debugger;
      docshow.value = false;
      iframeLoaded.value = false;
      ReportUrl.value = "";

      if (FieldsList.value && FieldsList.value.length > 0) {
        FieldsList.value = FieldsList.value.map((item) => {
          if (item.field_status == 3) {
            item.modelvalue = "";
            AutoCompleteNameList.value.ItemId = "";
            AutoCompleteNameList.value.StoreId = "";
            AutoCompleteNameList.value.CategoryId = "";
            AutoCompleteNameList.value.GRNNo = "";
            AutoCompleteNameList.value.DocNo = "";
            AutoCompleteNameList.value.SupplierId = "";
            AutoCompleteNameList.value.ConsumptionCode = "";

            AutoCompleteNameList.value.GroupId = "";
            AutoCompleteNameList.value.SubGroupId = "";
            AutoCompleteNameList.value.ToStoreId = "";
            AutoCompleteNameList.value.BrandId = "";
            AutoCompleteNameList.value.ModelId = "";
            AutoCompleteNameList.value.SizeId = "";
          }

          if (item.field_status == 4) {
            item.textfield = "";
          }

          if (item.field_status == 5) {
            item.dropdown = null;
          }
          resetField(item.label_name);
          return item;
        });
      }
      DataItems.value.fromdate = "";
      DataItems.value.Todate = "";

      ObjDataItems.value.Id = 0;
      ObjDataItems.value.ExpiryDays = 0;
      ObjDataItems.value.itemid = 0;
      ObjDataItems.value.docno = 0;
      ObjDataItems.value.consumptioncode = 0;
      ObjDataItems.value.grnno = 0;
      ObjDataItems.value.supplierid = 0;
      ObjDataItems.value.categoryid = 0;
      ObjDataItems.value.hospitalid = 0;
      ObjDataItems.value.branchid = 0;

      ObjDataItems.value.groupid = 0;
      ObjDataItems.value.subgroupid = 0;
      ObjDataItems.value.tostoreid = 0;
      ObjDataItems.value.brandid = 0;
      ObjDataItems.value.modelid = 0;
      ObjDataItems.value.sizeid = 0;
      ObjDataItems.value.storebrmapid = 0;
    };

    const DateOnChange = () => {
      debugger;
      docshow.value = false;
      iframeLoaded.value = false;
      ReportUrl.value = "";
    };

    const ExpiryDaysOption = ref([
      {
        name: "30 days",
        value: 30,
      },
      {
        name: "45 days",
        value: 45,
      },
      {
        name: "60 days",
        value: 60,
      },
      {
        name: "90 days",
        value: 90,
      },
      {
        name: "180 days",
        value: 180,
      },
      {
        name: "More than 180 days",
        value: 181,
      },
    ]);

    const DropdownOnChange = (data) => {
      debugger;
      ObjDataItems.value.ExpiryDays = data;
      docshow.value = false;
      iframeLoaded.value = false;
      ReportUrl.value = "";
    };

    const TextfieldOnChange = () => {
      debugger;
      docshow.value = false;
      iframeLoaded.value = false;
      ReportUrl.value = "";
    };

    //Submit Report
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      SubmitLoader.value = true;
      iframeLoaded.value = false;

      docshow.value = false;

      setTimeout(() => {
        ObjDataItems.value.hospitalid = usersData.OrganizationId;
        ObjDataItems.value.branchid = usersData.BranchId;

        ObjDataItems.value.fromdate = moment(DataItems.value.fromdate).format(
          "YYYY/MM/DD HH:mm:ss"
        );
        ObjDataItems.value.Todate = moment(DataItems.value.Todate).format(
          "YYYY/MM/DD HH:mm:ss"
        );

        // ReportUrl.value =
        //   "http://localhost:22463/Webform/WebForm1.aspx?FormId=" +
        //   DataItems.value.FormId +
        //   "&ClientId=" +
        //   usersData.OrganizationId +
        //   "&BranchId=" +
        //   usersData.BranchId +
        //   "&JsonValue=" +
        //   JSON.stringify(ObjDataItems.value) + "&ModuleId=3";

        // ReportUrl.value =
        //   "https://moceroreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
        //   DataItems.value.FormId +
        //   "&ClientId=" +
        //   usersData.OrganizationId +
        //   "&BranchId=" +
        //   usersData.BranchId +
        //   "&JsonValue=" +
        //   JSON.stringify(ObjDataItems.value) +
        //   "&ModuleId=3";

        // ReportUrl.value =
        //   "https://mopreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
        //   DataItems.value.FormId +
        //   "&ClientId=" +
        //   usersData.OrganizationId +
        //   "&BranchId=" +
        //   usersData.BranchId +
        //   "&JsonValue=" +
        //   JSON.stringify(ObjDataItems.value) +
        //   "&ModuleId=3";

        // ReportUrl.value =
        //   "https://aravindreports.mocerohealth.com/Webform/WebForm1.aspx?FormId=" +
        //   DataItems.value.FormId +
        //   "&ClientId=" +
        //   usersData.OrganizationId +
        //   "&BranchId=" +
        //   usersData.BranchId +
        //   "&JsonValue=" +
        //   JSON.stringify(ObjDataItems.value) +
        //   "&ModuleId=3";

        // ReportUrl.value =
        //   // "http://172.17.1.21/storesreport/Webform/WebForm1.aspx?FormId=" +
        //   "https://uatstoresreport.aravind.org/Webform/WebForm1.aspx?FormId=" +
        //   DataItems.value.FormId +
        //   "&ClientId=" +
        //   usersData.OrganizationId +
        //   "&BranchId=" +
        //   usersData.BranchId +
        //   "&JsonValue=" +
        //   JSON.stringify(ObjDataItems.value) +
        //   "&ModuleId=3";

        ReportUrl.value =
          config.API_MS_INVENTORY_REPORT_URL +
          "Webform/WebForm1.aspx?FormId=" +
          DataItems.value.FormId +
          "&ClientId=" +
          usersData.OrganizationId +
          "&BranchId=" +
          usersData.BranchId +
          "&JsonValue=" +
          JSON.stringify(ObjDataItems.value) +
          "&ModuleId=3";

        docshow.value = true;
      }, 100);
      // }
    });

    function Print() {
      debugger;

      ObjDataItems.value.hospitalid = usersData.OrganizationId;
      ObjDataItems.value.branchid = usersData.BranchId;

      ReportUrl.value = "";
      ObjDataItems.value.fromdate = moment(DataItems.value.fromdate).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      ObjDataItems.value.Todate = moment(DataItems.value.Todate).format(
        "YYYY/MM/DD HH:mm:ss"
      );

      // ReportUrl.value =
      //   "http://localhost:22463/Webform/WebForm1.aspx?FormId=" +
      //   DataItems.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ObjDataItems.value) + "&ModuleId=3";

      // ReportUrl.value =
      //   "https://moceroreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
      //   DataItems.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ObjDataItems.value) +
      //   "&ModuleId=3";

      // ReportUrl.value =
      //   "https://mopreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
      //   DataItems.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ObjDataItems.value) +
      //   "&ModuleId=3";

      // ReportUrl.value =
      //   "https://aravindreports.mocerohealth.com/Webform/WebForm1.aspx?FormId=" +
      //   DataItems.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ObjDataItems.value) +
      //   "&ModuleId=3";

      // ReportUrl.value =
      //   // "http://172.17.1.21/storesreport/Webform/WebForm1.aspx?FormId=" +
      //   "https://uatstoresreport.aravind.org/Webform/WebForm1.aspx?FormId=" +
      //   DataItems.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ObjDataItems.value) +
      //   "&ModuleId=3";

      ReportUrl.value =
        config.API_MS_INVENTORY_REPORT_URL +
        "Webform/WebForm1.aspx?FormId=" +
        DataItems.value.FormId +
        "&ClientId=" +
        usersData.OrganizationId +
        "&BranchId=" +
        usersData.BranchId +
        "&JsonValue=" +
        JSON.stringify(ObjDataItems.value) +
        "&ModuleId=3";

      window.open(ReportUrl.value, "_blank");
    }

    //Clear function
    function IsClear() {
      Object.assign(DataItems.value, copyDataItems);
      Object.assign(ObjDataItems.value, copyObjDataItems);
    }

    /*--*/
    return {
      ObjDataItems,
      showsecondiv,
      docshow,
      ReportsList,
      GetFieldList,
      ActiveIndex,
      reportsCollapse,
      FieldsList,
      DataItems,
      //GetByLeadCode,
      ReportUrl,
      IsSubmit,
      Print,
      loadStore,
      loadItem,
      // ObjItems,
      reprtname,
      loadoptions,
      selectOptions,
      ItemselectOptions,
      DocNoselectOptions,
      GRNNoselectOptions,
      ConsumptionCodeselectOptions,
      SupplierselectOptions,
      CategoryselectOptions,
      iframeLoaded,
      onIframeLoad,
      BtnCancel,
      SubmitLoader,
      TodayDate,
      ReportTitle,
      DateOnChange,
      DropdownOnChange,
      TextfieldOnChange,
      AutoCompleteNameList,
      ExpiryDaysOption,
      groupselectOptions,
      subGroupselectOptions,
      tostoreselectOptions,
      brandselectOptions,
      modelselectOptions,
      sizeselectOptions,
      BatchnoselectOptions,
    };
  },
});
</script>

<style lang="scss">
.reports-div {
  display: flex;
  // height: 78vh;
  overflow: auto;
  margin: 5px 0px;
}

.first-div {
  width: 25%;
  // height: 100%;
  overflow: auto;
  border: 1px solid #e1e1e1;
}

.second-div {
  padding: 2px 5px;
  // width: -webkit-fill-available;
  border: 1px solid #e1e1e1;
  flex: 1;
}

.iframe-class {
  width: 100%;
  min-height: 600px;
  overflow-y: auto;
}

.reports-list .btn-content {
  width: 100%;
  color: #000000;
  cursor: pointer;
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 5px;
  border: 1px solid #e1e1e1;
}

.reports-list .p-button {
  background: none;
  border: none;
  padding: 0rem 0rem;
  font-size: 14px;
  width: 98%;
}

.reports-list #collapse-1 {
  padding: 0px 5px;
}

.reports-list #collapse-1 ul,
.reports-list #collapse-1 ul li {
  border: 1px solid #e1e1e1;
  padding: 5px;
}

.reports-list .p-button:enabled:hover {
  background: none;
  color: #000000;
  border: 1px solid #e1e1e1;
}

.s-list span,
.reports-list span {
  font-size: 14px;
  color: #000000;
}

.reports-list .pi {
  font-size: 14px;
  color: #000000;
}

.reports-list #collapse-1-inner {
  padding: 0px 0px 0px 0px;

  li {
    padding: 5px 5px;
  }
}

.reports-list li span {
  color: #000000;
  padding: 8px 5px;
}

.reports-list .collapsed .pi {
  transform: rotate(180deg);
}

.collapse ul li {
  cursor: pointer;
}

.printbtn {
  border: none !important;
  padding: 0.5rem 0.65rem 0.5rem 0.65rem !important;
  font-size: 14px !important;
  white-space: nowrap;
  border-radius: 8px !important;
}

.active-report span {
  color: #0a82ff !important;
}
</style>
